import { render } from "./PackagesManagerOrdersCentralListGrouped.vue?vue&type=template&id=78544860&scoped=true"
import script from "./PackagesManagerOrdersCentralListGrouped.vue?vue&type=script&lang=js"
export * from "./PackagesManagerOrdersCentralListGrouped.vue?vue&type=script&lang=js"

import "./PackagesManagerOrdersCentralListGrouped.vue?vue&type=style&index=0&id=78544860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78544860"]])

export default __exports__